import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ListingSizeComponentDef } from '@df/catalog-ui/listing/size/listing-size.component.def';

@Component({
    selector: 'listing-size',
    templateUrl: './listing-size.html',
    styleUrl: './listing-size.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingSizeComponent extends ListingSizeComponentDef {}
